// extracted by mini-css-extract-plugin
export var fileUpload = "_ig-1";
export var modalButton = "_ig-0";